import { useEffectOnce } from '@weee-fe/utilities';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const TIME_BANNER_ALWAYS_STICKY = true; // No longer needed to observe scroll and change theme.  meta theme-color is set as long as "ThemeNavBarColorObserver" is rendered

const ThemeNavBarColorObserver = ({ visibleColor = '#F23B7D', hiddenColor = '#FFFFFF' }) => {
  const pixelRef = useRef(null);
  const router = useRouter();
  const pathname = router?.asPath;

  const setMetaThemeColor = (color: string) => {
    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute('content', color);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'theme-color';
      newMeta.content = color;
      document.head.appendChild(newMeta);
    }
  };

  useEffect(() => {
    const isKnownFixedPromoRoute = pathname?.indexOf('/cart') > -1 || pathname?.indexOf('/product/') > -1;
    if (TIME_BANNER_ALWAYS_STICKY || isKnownFixedPromoRoute) {
      setMetaThemeColor(visibleColor);
      return null;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const isIntersecting = entry.isIntersecting;
          setMetaThemeColor(isIntersecting ? visibleColor : hiddenColor);
        });
      },
      {
        threshold: 1,
        rootMargin: '0px'
      }
    );

    if (pixelRef?.current) {
      observer.observe(pixelRef?.current);
    }

    // Cleanup
    return () => {
      if (pixelRef?.current) {
        observer?.unobserve(pixelRef?.current);
      }
      // Reset color on unmount
      setMetaThemeColor(hiddenColor);
    };
  }, [pathname, visibleColor, hiddenColor]);

  useEffectOnce(() => {
    // Set initial color
    setMetaThemeColor(visibleColor);
  });

  return (
    <div ref={pixelRef} className={` w-[1px] h-[1px] bg-transparent absolute bottom-0 right-0`} aria-hidden="true" />
  );
};

export default ThemeNavBarColorObserver;
